import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie } from '@fortawesome/free-solid-svg-icons';
import { Pie } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { blueShades } from '../utils/colors'; 


ChartJS.register(ArcElement, Tooltip, Legend);

const ContainerTypeDistributionCard = () => {
  const { data, isLoading } = useContext(DataContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  // Process the data to count different container types
  const containerTypeCounts = data.reduce((acc, item) => {
    item.container_data.forEach(container => {
      const containerType = container.type.trim(); 
      acc[containerType] = (acc[containerType] || 0) + 1;
    });
    return acc;
  }, {});

  const chartData = {
    labels: Object.keys(containerTypeCounts),
    datasets: [
      {
        label: 'Container Types',
        data: Object.values(containerTypeCounts),
        backgroundColor: blueShades.slice(0, Object.keys(containerTypeCounts).length),
        hoverBackgroundColor: blueShades.slice(0, Object.keys(containerTypeCounts).length),
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg flex flex-col justify-between h-custom-card-big overflow-y-auto">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartPie} className="text-blue-600 mr-2" />
          Container Type Distribution
        </h2>
      </div>
      <div className="flex-grow relative h-full">
        <Pie data={chartData} options={options} />
      </div>
    </div>
  );
};

export default ContainerTypeDistributionCard;
